<template>
  <div class="modal-wrapper">
    <div class="modal">
      <header>
        <p>
          <strong
            >Добави части и доставчици към
            <template v-if="type === 'material'">избрания материал</template>
            <template v-else-if="type === 'activity'"
              >избраната дейност</template
            >
          </strong>
        </p>
      </header>
      <div class="modal-content">
        <header>
          <strong>Част</strong>
          <strong>Доставчик</strong>
        </header>
        <div class="row" v-for="(r, i) in rows" :key="`row-${i}`">
          <div class="select-wrapper">
            <select v-model="r.part">
              <option value disabled selected hidden>Асоцирай към част</option>
              <option value v-if="r.part">Премахни част</option>
              <option v-for="(p, j) in parts" :value="p" :key="`part-${j}`">{{
                p.partName
              }}</option>
              <option :value="{ partName: 'Друга част' }">Друга част</option>
            </select>
          </div>
          <span
            class="miv2 comment-toggle"
            @click="commentingPart = i"
            :title="r.partComment || 'Добавете коментар'"
          >
            <span v-if="r.partComment">\</span>
            <span v-else>[</span>
          </span>
          <div class="select-wrapper">
            <select v-model="r.supplier">
              <option value disabled selected hidden
                >От къде идва стоката *</option
              >
              <option value="Ел Енерджи">Ел Енерджи</option>
              <option value="СИС /V-tac/ - магазин Черни връх"
                >СИС /V-tac/ - магазин Черни връх</option
              >
              <option value="Ел Ди Джи">Ел Ди Джи</option>
              <option value="Текра">Текра</option>
              <option value="Семо">Семо</option>
              <option value="Обо Бетерман">Обо Бетерман</option>
              <option value="Ковас">Ковас</option>
              <option value="Електротрейд">Електротрейд</option>
              <option value="Склад">Склад</option>
              <option value="Друг доставчик">Друг доставчик</option>
              <option value="Няма доставка">Няма доставка</option>
            </select>
          </div>
          <span
            class="miv2 comment-toggle"
            @click="commentingSupplier = i"
            :title="r.supplierComment || 'Добавете коментар'"
          >
            <span v-if="r.supplierComment">\</span>
            <span v-else>[</span>
          </span>
          <span class="miv2 rem-toggle" v-if="i" @click="remove(i)">]</span>
          <span class="miv2 add-toggle" v-else @click="add">^</span>
        </div>
      </div>
      <div class="btns">
        <button class="btn btn-close" @click="close()">
          <span class="miv">F</span>
          Отказ
        </button>
        <button class="btn btn-new" @click="save()">
          <span class="miv">Y</span>
          Запази
        </button>
      </div>
    </div>
    <CommentModal
      v-if="commentingPart > -1"
      :value="rows[commentingPart].partComment"
      @save="(rows[commentingPart].partComment = $event), (commentingPart = -1)"
      @close="commentingPart = -1"
    />
    <CommentModal
      v-if="commentingSupplier > -1"
      :value="rows[commentingSupplier].supplierComment"
      @save="
        (rows[commentingSupplier].supplierComment = $event),
          (commentingSupplier = -1)
      "
      @close="commentingSupplier = -1"
    />
  </div>
</template>

<script>
import CommentModal from './CommentModal';
export default {
  components: {
    CommentModal,
  },
  props: ['item', 'parts', 'type'],
  data() {
    return {
      commentingPart: -1,
      commentingSupplier: -1,
      rows: [],
    };
  },
  methods: {
    remove(i) {
      this.rows.splice(i, 1);
    },
    add() {
      const row = {
        part: '',
        partComment: '',
        supplier: '',
        supplierComment: '',
      };

      if (this.type === 'activity') {
        row.price = this.item.activityPrice;
      } else if (this.type === 'material') {
        row.price = this.item.materialPrice;
      }
      row.quantity = 0;

      this.rows.push(row);
    },
    close() {
      this.$emit('close');
    },
    save() {
      for (let r of this.rows) {
        if (!r.part) {
          return this.$snotify.error(
            'Трябва да изберете част на всички редове.'
          );
        } else if (r.part) {
          if (r.part.partName === 'Друга част' && !r.partComment) {
            return this.$snotify.error(
              "Когато е избрана 'Друга част' коментарът е задължителен."
            );
          }
        }
        if (!r.supplier) {
          return this.$snotify.error(
            'Трябва да отбележите от къде идва стоката на всички редове.'
          );
        } else if (r.supplier === 'Друг доставчик') {
          if (!r.supplierComment) {
            return this.$snotify.error(
              "Когато е избран 'Друг доставчик' коментарът е задължителен."
            );
          }
        }
      }

      this.$emit('save', this.rows);
    },
  },
  mounted() {
    this.rows = this.item.rows || [];
    if (!this.rows.length) this.add();
    // ensure that it's a fresh copy of the array
    this.rows = this.rows.slice();
  },
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
.modal {
  width: 720px;
  padding: 12.5px 12px 9px 17px;
}
.modal > header {
  text-align: center;
  padding-right: 5px;
}
.modal-content {
  margin: 30px 0;
  padding: 0 5px 0 0;
}
.modal-content::-webkit-scrollbar {
  width: 5px;
}
.modal-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(217, 217, 217, 0.8);
}
.modal-content::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 10px;
}
.modal-content > header {
  color: #005a9e;
  display: flex;
  margin-bottom: 9px;
  padding-right: 32px;
  width: 100%;
}
.modal-content > header strong {
  width: 50%;
}
.row {
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  width: 100%;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.select-wrapper {
  width: 100%;
}
.select-wrapper select {
  width: 100%;
}
.comment-toggle {
  color: #1c4564;
  cursor: pointer;
  font-size: 20px;
  margin: 0 10px 0 5px;
  transition: all 0.2s;
}
.comment-toggle:hover {
  opacity: 0.8;
}
.add-toggle,
.rem-toggle {
  align-items: center;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 20px;
  height: 32px;
  justify-content: center;
  min-width: 32px;
  width: 32px;
  transition: all 0.2s;
}
.add-toggle:hover,
.rem-toggle:hover {
  opacity: 0.8;
}
.add-toggle {
  background-color: #3b86ff;
}
.rem-toggle {
  background-color: #cc0808;
}
.btns {
  justify-content: center;
  padding-right: 5px;
}
.btns .btn:first-child {
  margin-left: 0;
}
</style>
